import { useContext } from "react";
import { GenericModalContext } from "./index";

export const useGenericModal = () => {
  return useContext(GenericModalContext);
};
